import React from 'react'
import PropTypes from 'prop-types'

function Table({notifications}) {
  return <table className='table table-striped'>
    <thead>
      <tr>
        <th>Title</th>
        <th>Message</th>
        <th>User</th>
        <th>Regions</th>
        <th>Sent on</th>
      </tr>
    </thead>
    <tbody>
      { 
        notifications.map((notification, index) => {
          return <tr key={index}>
            <td>{notification.title}</td>
            <td>{notification.message}</td>
            <td>{notification.user}</td>
            <td>{notification.regions}</td>
            <td>{notification.created_at}</td>
          </tr>
        })
      }
    </tbody>
  </table>
}

Table.propTypes = {
  notifications: PropTypes.array.isRequired,
}

export default Table

